import React from "react";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { GreyCard, GreyCardProps } from "../../components/GreyCard";
import { GroupedComponents } from "../../components/GroupedComponents";
import { List } from "../../components/List";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { PricingTable, PricingTableProps } from "../../components/PricingTable";
import { ProcessSteps, ProcessStepsProps } from "../../components/ProcessSteps";
import { Responsibilities, ResponsibilitiesProps } from "../../components/Responsibilities";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";
import { GenericListProps } from "../../types/GenericListType";

export interface DistributedGenerationBigPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  lists?: GenericListProps[];
  responsibilities?: ResponsibilitiesProps[];
  tables?: PricingTableProps[];
  processes?: ProcessStepsProps[];
  wantToReport?: GreyCardProps;
  faqs?: FaqAccordionGroupProps;
}

export const DistributedGenerationBigPage: React.FC<DistributedGenerationBigPageProps> = ({
  seo,
  pageTitle,
  paragraphs,
  lists,
  responsibilities,
  tables,
  processes,
  wantToReport,
  faqs,
}) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      <GroupedComponents>
        {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
        {lists && lists[0] && <List {...lists[0]} />}
        {paragraphs && paragraphs[1] && <Paragraph {...paragraphs[1]} />}
      </GroupedComponents>
      {responsibilities && responsibilities[0] && <Responsibilities {...responsibilities[0]} />}
      {tables && tables[0] && <PricingTable {...tables[0]} />}
      {tables && tables[1] && <PricingTable {...tables[1]} />}
      {processes && processes[0] && <ProcessSteps {...processes[0]} />}
      {wantToReport && <GreyCard {...wantToReport} />}
    </ServiceCataloguePageWrapper>
  );
};
